/**
 * 统一的存储管理工具
 * 使用 localStorage 替代 sessionStorage，使得登录状态可以在多个标签页间共享
 */

const storage = {
  // 获取存储的值
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error getting item from storage:', error);
      return null;
    }
  },

  // 设置存储的值
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error setting item to storage:', error);
    }
  },

  // 删除存储的值
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing item from storage:', error);
    }
  },

  // 清空所有存储
  clear: () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  }
};

export default storage;
